/* Две-три строчки фактов, ради которых игрок вообще смотрит на лот.
   У каждого типа имущества они свои: у машины — салон, пробег и номер,
   у дома — район и сколько человек селится, у бизнеса — район и вид. */
import { formatThousands } from './modules/money'
import { BUSINESS_TYPES } from './configs/sort'

const BIZ_BY_ID = {
    0: 'Магазин 24/7', 1: 'АЗС', 2: 'Автосалон', 3: 'Автосалон', 4: 'Автосалон',
    5: 'Автосалон', 6: 'Оружейный магазин', 7: 'Магазин одежды', 8: 'Магазин 24/7',
    9: 'Тату-салон', 10: 'Барбершоп', 12: 'Тюнинг-ателье', 13: 'Автомойка', 15: 'Автосалон',
};

export const factsOf = (data) => {
    if (!data || !data.params) return [];
    const p = data.params;

    switch (data.type) {
        case 'vehicle':
            return [p.motorShow, p.mileage != null ? formatThousands (p.mileage) + ' км' : null, p.numberPlate];
        case 'house':
            return [p.area, p.garages ? p.garages + ' гар.' : null, p.people ? 'на ' + p.people + ' чел.' : null];
        case 'business': {
            /* название лота у бизнеса — это уже «Магазин 24/7 #3»; повторять
               вид второй строкой незачем */
            const kind = BIZ_BY_ID[p.type] || null;
            const inName = kind && String (p.name || '').toLowerCase ().includes (kind.toLowerCase ());
            return [p.area, inName ? null : kind];
        }
        case 'item':
            return [data.count ? formatThousands (data.count) + ' шт. в продаже' : null];
        case 'clothes':
            return [p.gender === 'True' ? 'мужская' : 'женская', data.count ? formatThousands (data.count) + ' шт.' : null];
        case 'service':
            return ['услуга'];
    }
    return [];
};

export const factsLine = (data) => factsOf (data).filter (Boolean).join (' · ');

export { BUSINESS_TYPES };
